module.exports = __webpack_public_path__ + "fonts/TiemposHeadline-Bold.6831e5a4.ttf";